export * from "./LargePicture";
export * from "./LargePicture.types";
